module.exports = "/_next/static/images/cabs-service-3-4f51124728c864e90f7a751a40a39002.webp";